import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {
  NotificationsPanelReduxState,
  Notification,
  NotificationAJAXResponse,
  NotificationSettingsPanelData,
  NotificationUpdateDispatchType,
} from '@Panels/notifications-panel/notifications-panel.types';
import {NotificationsPanelDisplayType} from '@Panels/notifications-panel/notifications-panel.types';

const notificationSettingsIntialState: NotificationSettingsPanelData = {
  teamUpdates: false,
  designUpdates: false,
  emailCampaigns: false,
  socialMediaPosts: false,
  eventsUpdates: false,
};

const initialState: NotificationsPanelReduxState = {
  panelDisplayType: NotificationsPanelDisplayType.LOADING, // or whichever default makes sense
  newNotifications: [],
  todaysNotifications: [],
  yesterdaysNotifications: [],
  otherNotifications: [],
  allNotifications: [],
  notificationSettings: notificationSettingsIntialState,
  previousNotificationSettings: notificationSettingsIntialState,
};

const notificationsPanelSlice = createSlice({
  name: 'notificationsPanel',
  initialState,
  reducers: {
    setPanelDisplayType: (state, action: PayloadAction<NotificationsPanelDisplayType>) => {
      state.panelDisplayType = action.payload;
    },
    setAllNotificationsDataFromAjax: (state, action: PayloadAction<NotificationAJAXResponse>) => {
      state.newNotifications = action.payload.new;
      state.otherNotifications = action.payload.others;
      state.todaysNotifications = action.payload.today;
      state.yesterdaysNotifications = action.payload.yesterday;
      state.notificationSettings = action.payload.notificationSettings;
      state.previousNotificationSettings = action.payload.notificationSettings;
      state.allNotifications = [...action.payload.new, ...action.payload.others, ...action.payload.today, ...action.payload.yesterday];
    },
    updateNotificationsAfterStatusUpdate: (state, action: PayloadAction<NotificationUpdateDispatchType>) => {
      state.todaysNotifications = action.payload.today;
      state.yesterdaysNotifications = action.payload.yesterday;
      state.otherNotifications = action.payload.others;
      state.newNotifications = [];
    },
    showDesignUpdates: (state, action: PayloadAction<boolean>) => {
      state.notificationSettings.designUpdates = action.payload;
    },
    showTeamUpdates: (state, action: PayloadAction<boolean>) => {
      state.notificationSettings.teamUpdates = action.payload;
    },
    showEmailCampaignUpdates: (state, action: PayloadAction<boolean>) => {
      state.notificationSettings.emailCampaigns = action.payload;
    },
    showSocialMediaPostsUpdates: (state, action: PayloadAction<boolean>) => {
      state.notificationSettings.socialMediaPosts = action.payload;
    },
    showEventsUpdates: (state, action: PayloadAction<boolean>) => {
      state.notificationSettings.eventsUpdates = action.payload;
    },
    setNotificationSettings: (state, action: PayloadAction<NotificationSettingsPanelData>) => {
      state.notificationSettings = action.payload;
    },
    setAllNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.allNotifications = action.payload;
    },
    setPreviousNotificationSettings: (state, action: PayloadAction<NotificationSettingsPanelData>) => {
      state.previousNotificationSettings = action.payload;
    },
    setNewNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.newNotifications = [...action.payload, ...state.newNotifications];
      state.allNotifications = [...action.payload, ...state.allNotifications];
    },
  },
});

export const {
  setPanelDisplayType,
  setAllNotificationsDataFromAjax,
  updateNotificationsAfterStatusUpdate,
  showSocialMediaPostsUpdates,
  showEmailCampaignUpdates,
  showDesignUpdates,
  showTeamUpdates,
  setNotificationSettings,
  setAllNotifications,
  setPreviousNotificationSettings,
  setNewNotifications,
  showEventsUpdates,
} = notificationsPanelSlice.actions;

export const notificationsPanelReducer = notificationsPanelSlice.reducer;
